import { render, staticRenderFns } from "./CourseQuesAns.vue?vue&type=template&id=5c059faa&scoped=true&"
import script from "./CourseQuesAns.vue?vue&type=script&lang=js&"
export * from "./CourseQuesAns.vue?vue&type=script&lang=js&"
import style0 from "./CourseQuesAns.vue?vue&type=style&index=0&id=5c059faa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c059faa",
  null
  
)

export default component.exports